import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	qrCodeWaitingProgress: {
		height: 44,
		width: "100%",
		borderRadius: theme.spacing(0.5),
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50])
	}
}))

export default useStyles
